export default function parseRss(rss: string) {
    const xml = new DOMParser().parseFromString(rss, "text/xml");
    return {
        eyebrow: parseEyebrow(xml) ?? "",
        imageUrl: parseImageUrl(xml),
        title: parseTitle(xml) ?? "",
        url: parseUrl(xml) ?? ""
    };
}

function parseEyebrow(xml: Document) {
    const categories: string[] = [];
    xml.querySelectorAll("item > category").forEach(
        (node) => node.textContent && categories.push(node.textContent)
    );
    return categories.length ? categories.join(" | ") : undefined;
}

function parseImageUrl(xml: Document) {
    const htmlString = xml.querySelector("item > description")?.textContent;
    if (!htmlString) return undefined;
    const html = new DOMParser().parseFromString(htmlString, "text/html");
    return html.querySelector("img")?.getAttribute("src")?.split("?")[0];
}

function parseTitle(xml: Document) {
    return xml.querySelector("item > title")?.textContent?.split(" | ")[0];
}

function parseUrl(xml: Document) {
    return xml.querySelector("item > link")?.textContent;
}
